import noop from 'lodash/noop';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import * as D from '../../../deps';
import * as OwnUtils from '../../../utils';
import RecommendationsGrid from '../RecommendationsGrid/RecommendationsGrid';

interface IRecommendedPodcastsAndStations {
  getBrowseDirectory: $TSFixMeFunction;
  hasFetchedData: boolean;
  hasStationRecommendations: boolean;
  loadStationRecommendations: $TSFixMeFunction;
  recommendedItems: [];
}
export class RecommendedPodcastsAndStations extends React.Component<IRecommendedPodcastsAndStations> {
  componentDidMount(): $TSFixMe {
    this.fetchItems();
  }

  componentDidUpdate(): $TSFixMe {
    this.fetchItems();
  }

  fetchItems = (): $TSFixMe => {
    if (!this.props.hasFetchedData) {
      this.props.loadStationRecommendations();
      this.props.getBrowseDirectory({
        directoryId: D.Constants.Podcasts.RECOMMENDED_PODCAST_DIRECTORY_ID,
      });
      this.props.getBrowseDirectory({
        directoryId: D.Constants.Podcasts.RECOMMENDED_EPISODE_DIRECTORY_ID,
      });
    }
  };

  getItems = (): $TSFixMe => {
    return this.props.recommendedItems.map((item: $TSFixMe, i) => {
      if (D.isPodcastPandoraType(item.pandoraType)) {
        return <D.MixedGridItem key={i} {...item} isMixedWithOtherSources={true} />;
      } else if (item.pandoraType === D.Constants.SourceTypes.PandoraTypes.GENRE) {
        return <D.GenreStationGridItem key={i} musicId={item.id} />;
      }
      return <D.MixedGridItem key={i} {...item} />;
    });
  };

  getTitle = (): $TSFixMe => {
    return <FormattedMessage {...D.Constants.Podcasts.messages.recommendedForYou} />;
  };

  render(): $TSFixMe {
    if (!this.props.hasFetchedData) return null;

    return (
      <div className='RecommendedPodcastsAndStations'>
        {this.props.hasStationRecommendations && this.props.recommendedItems.length ? (
          <RecommendationsGrid items={this.getItems()} title={this.getTitle()} />
        ) : (
          <D.BrowseGenreBestOfPandora />
        )}
      </div>
    );
  }
}

export function mapStateToProps(state: $TSFixMe): $TSFixMe {
  const hasFetchedPodcastPrograms = !!OwnUtils.getBrowseDeepLevelSection(
    state,
    D.Constants.Podcasts.RECOMMENDED_PODCAST_DIRECTORY_ID,
  );
  const hasFetchedPodcastEpisodes = !!OwnUtils.getBrowseDeepLevelSection(
    state,
    D.Constants.Podcasts.RECOMMENDED_EPISODE_DIRECTORY_ID,
  );
  const hasStationRecommendations = D.getInDomain(
    'playback.utils.areStationRecommendationsLoaded',
    false,
  )(state);
  const hasFetchedGenreStations = !D.Utils.Api.isRequestInFlight(state, {
    endpoint: D.Constants.Api.ApiEndpoints.SEARCH_RECOMMENDATIONS,
  });

  const hasFetchedData =
    hasFetchedPodcastPrograms && hasFetchedPodcastEpisodes && hasFetchedGenreStations;
  const recommendedItems = hasFetchedData
    ? OwnUtils.getRecommendedPodcastsAndGenreStations(state)
    : null;

  return {
    hasFetchedData,
    hasStationRecommendations,
    recommendedItems,
  };
}

// eslint-disable-next-line react-redux/mapDispatchToProps-returns-object
export function mapDispatchToProps(dispatch: $TSFixMe): $TSFixMe {
  return bindActionCreators(
    {
      getBrowseDirectory: D.getInDomain('discovery.actions.getBrowseDirectory', noop),
      loadStationRecommendations: D.getInDomain(
        'playback.actions.loadStationRecommendations',
        noop,
      ),
    },
    dispatch,
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(RecommendedPodcastsAndStations);
